export const translations = {
  ko: {
    appTitle: 'MSL 보석 매니저',
    appSubtitle: '내 PC의 보석 데이터를 브라우저에서 관리하고 스타몬별 추천 조합을 계산합니다.',
    loadJson: 'JSON 불러오기',
    saveJson: '원본 파일에 저장',
    exportJson: 'JSON 내보내기',
    imageFolder: '이미지 폴더 연결',
    noData: 'parsed_gems.json을 불러오면 시작할 수 있습니다.',
    localOnly: '보석 데이터는 서버에 업로드하지 않고 현재 브라우저에서만 처리합니다.',
    list: '보석 목록',
    review: '개별 검수',
    recommend: '맞춤 세팅기',
    equipped: '장착 스타몬',
    pending: '보류',
    trash: '휴지통',
    language: '언어',
    dataLoaded: '데이터 불러옴',
    normal: '정상',
    uncertain: '검수 필요',
    search: '검색',
    all: '전체',
    shape: '모양',
    enhancement: '강화',
    mainStat: '주옵션',
    subStats: '부옵션',
    setOption: '세트옵션',
    equippedTo: '장착 스타몬',
    fileName: '파일명',
    moveTrash: '휴지통으로 이동',
    restore: '복구',
    deletePermanent: '영구 삭제',
    saveChanges: '변경사항 저장',
    previous: '이전',
    next: '다음',
    imageMissing: '이미지를 찾을 수 없습니다.',
    chooseMonster: '스타몬 선택',
    runRecommend: 'Top 3 조합 찾기',
    saveCombo: '이 조합 장착 저장',
    unequip: '장착 해제',
    exactSearch: '정확 탐색',
    optimizedSearch: '브라우저 최적화 탐색',
    discardChanges: '저장하지 않은 변경사항이 있습니다. 다른 JSON을 열고 변경사항을 버릴까요?',
  },
  en: {
    appTitle: 'MSL Gem Manager',
    appSubtitle: 'Manage local gem data in your browser and calculate Astromon gem recommendations.',
    loadJson: 'Open JSON',
    saveJson: 'Save to source file',
    exportJson: 'Export JSON',
    imageFolder: 'Connect image folder',
    noData: 'Open parsed_gems.json to begin.',
    localOnly: 'Gem data is processed in your browser and is not uploaded to the server.',
    list: 'Gem List',
    review: 'Review / Edit',
    recommend: 'Recommender',
    equipped: 'Equipped Astromons',
    pending: 'Pending',
    trash: 'Trash',
    language: 'Language',
    dataLoaded: 'Data loaded',
    normal: 'Normal',
    uncertain: 'Needs review',
    search: 'Search',
    all: 'All',
    shape: 'Shape',
    enhancement: 'Enhancement',
    mainStat: 'Main stat',
    subStats: 'Sub-stats',
    setOption: 'Set effect',
    equippedTo: 'Equipped to',
    fileName: 'File name',
    moveTrash: 'Move to trash',
    restore: 'Restore',
    deletePermanent: 'Delete permanently',
    saveChanges: 'Save changes',
    previous: 'Previous',
    next: 'Next',
    imageMissing: 'Image not found.',
    chooseMonster: 'Choose Astromon',
    runRecommend: 'Find Top 3',
    saveCombo: 'Save as equipped',
    unequip: 'Unequip',
    exactSearch: 'Exact search',
    optimizedSearch: 'Browser-optimized search',
    discardChanges: 'You have unsaved changes. Open another JSON and discard them?',
  },
};

export const STAT_EN = {
  공격력: 'Attack', 체력: 'HP', 방어력: 'Defense', 회복력: 'Recovery',
  치명확률: 'Crit. Rate', 치명타피해: 'Crit. Damage', 효과저항: 'Resistance', 효과적중: 'Accuracy',
};

export const SHAPE_EN = { 네모: 'Square', 세모: 'Triangle', 마름모: 'Diamond' };

export function createTranslator(lang) {
  const dict = translations[lang] || translations.ko;
  return (key) => dict[key] ?? translations.ko[key] ?? key;
}
